import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'grid',
    title: 'heading-2xl mb-6',
    items: 'scrollbar-hidden flex gap-6 overflow-x-scroll lg:gap-10',
    item: 'heading-s-bold flex w-30 min-w-30 flex-col items-center gap-4 whitespace-nowrap lg:w-40 lg:min-w-40',
    image: 'rounded-full'
  }
});
